export default __webpack_public_path__ + "static/media/slide3.35ac8486.png";